import React, { Component } from 'react';
import * as util from './util';

import './product-details.css';

export class CategoryPath extends Component {
  constructor(props) {
    super(props);
    this.display = this.display.bind(this);
    this.getFullPaths = this.getFullPaths.bind(this);

    this.state = {
      ids: null,
      startID: this.props.startID,
      fullPaths: null,
      shortView: [true, true, true, true, true, true, true, true, true, true, true, true] //<- this fixed length is bad
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.ids !== this.state.ids) {
      this.setState({
        ids: nextProps.ids,
      });
      this.getFullPaths(nextProps.ids);
    }
  }

  display(array,pos) {
    var newArray = [];
    if (this.state.shortView[pos] === false) {
      for (var i = 0; i < array.length; i++) {
        newArray.push(<span key={i} style={i + 1 < array.length ? { color: 'black' } : { color: 'green', fontWeight: 'bold' }}>{array[i]}</span>);
        if (i + 1 < array.length) {
          newArray.push(<span key={i+1000} style={{ color: 'green' }}> ▶ </span>);
        }
      }
    } else {
      var length = array.length - 1;
      newArray.push(<span key={i} style={{ color: 'green', fontWeight: 'bold'}}>▶ {array[length]} <br /></span>);
    }
    return newArray;
  }

  getFullPaths(ids) {
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    var url = `/api/category-full-paths?ids=${ids}&startid=${this.props.startID}`;
    var promise = fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: headers
    })
      .then(response => response.json())
      .catch(function (exception) {
        alert('Konnte den vollen Kategoriepfad nicht ermitteln!');
        console.error(`Could not retreive category node information!`, exception);
      });

    promise.then(function (json) {
      self.setState({ fullPaths: json });
    })
  }

  render() {
    const self = this;
    return (
      <div >
        <span >{(this.state.fullPaths !== null && this.state.fullPaths !== undefined) ? (this.state.fullPaths.map(function (elem, i) {
            return <p style={{cursor: 'pointer'}} key={i} onClick={function () {
                var newShortView = self.state.shortView.slice();
                newShortView[i] = !newShortView[i];
                self.setState({ shortView: newShortView })
              }}> {self.display(elem,i)} </p>
          })) : null}
        </span>
      </div >
    )
  }
}

export class CategoryPathWithLabel extends Component {
  constructor(props) {
    super(props);
    this.display = this.display.bind(this);
    this.getFullPaths = this.getFullPaths.bind(this);

    this.state = {
      ids: null,
      startID: this.props.startID,
      fullPaths: null,
      shortView: [true, true, true, true, true, true, true, true, true, true, true, true] //<- this fixed length is bad
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.ids !== this.state.ids) {
      this.setState({
        ids: nextProps.ids,
      });
      this.getFullPaths(nextProps.ids);
    }
  }

  display(array,pos) {
    var newArray = [];
    if (this.state.shortView[pos] === false) {
      for (var i = 0; i < array.length; i++) {
        newArray.push(<span key={i} style={i + 1 < array.length ? { color: '#1F6A81' } : { color: '#1F6A81', fontWeight: 'bold' }}>{array[i]}</span>);
        if (i + 1 < array.length) {
          newArray.push(<span key={i+1000} style={{ color: '#1F6A81' }}> ▶ </span>);
        }
      }
    } else {
      var length = array.length - 1;
      newArray.push(<span key={i} style={{ color: '#1F6A81', fontWeight: 'bold'}}>▶ {array[length]} <br /></span>);
    }
    return newArray;
  }

  getFullPaths(ids) {
    const self = this;
    var headers = util.defaultHeaders();
    headers.append("Accept", "application/json");
    var url = `/api/category-full-paths?ids=${ids}&startid=${this.props.startID}`;
    var promise = fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: headers
    })
      .then(response => response.json())
      .catch(function (exception) {
        alert('Konnte den vollen Kategoriepfad nicht ermitteln!');
        console.error(`Could not retreive category node information!`, exception);
      });

    promise.then(function (json) {
      self.setState({ fullPaths: json });
    })
  }

  render() {
    const self = this;
    return (
      <div className="marginTop2" >
        <div className="Bold">Kategorie</div>
        <span >{(this.state.fullPaths !== null && this.state.fullPaths !== undefined) ? (this.state.fullPaths.map(function (elem, i) {
            return <p style={{cursor: 'pointer'}} key={i} onClick={function () {
                var newShortView = self.state.shortView.slice();
                newShortView[i] = !newShortView[i];
                self.setState({ shortView: newShortView })
              }}> {self.display(elem,i)} </p>
          })) : null}
        </span>
      </div >
    )
  }
}




// WEBPACK FOOTER //
// ./src/show-categorypath.js